import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const editForumTopic = (data) => {
  return apiRequestType(
    apiTypes.PUT,
    apiConstants.SOCIAL.FORUM_AREA.EDIT_FORUM_TOPIC,
    data
  );
};

export default editForumTopic;
